export default __webpack_public_path__ + "ed5e8088fe719070c39646bb8ee0ddee.gif";